import React, { createContext, useEffect, useState, Component } from 'react';
import { userlogo } from '../../common/constants';
import { getLocalStorageData } from '../../common/resubale-functions';

export const MainContext = createContext();

export const ContextProvider = (props) => {
  const background = getLocalStorageData(userlogo, 'string');
  const [loginTokenContext, setLOginTokenContext] = useState('');
  const [userIdContext, setUserIdContext] = useState('');
  const [userLogoContext, setUserLogoContext] = useState(background);
  const [path, setPath] = useState('');

  useEffect(() => {
    if (background) setUserLogoContext(background);
  }, [background]);

  return (
    <MainContext.Provider
      value={{
        setLOginTokenContext: setLOginTokenContext,
        loginTokenContext: loginTokenContext,
        setUserIdContext: setUserIdContext,
        userIdContext: userIdContext,
        setUserLogoContext: setUserLogoContext,
        userLogoContext: userLogoContext,
        setPath: setPath,
        path: path,
      }}
    >
      {props.children}
    </MainContext.Provider>
  );
};
